import chroma from 'chroma-js';
import React, { memo } from 'react';
import styled, { keyframes } from 'styled-components';

function SpinningRing() {
    return (
        <Root viewBox="0 0 100 100">
            <TrackRing r={ 50 }
                cx={ 50 }
                cy={ 50 }
                strokeWidth={ 16 }
            />
            <LoadingRing r={ 50 }
                cx={ 50 }
                cy={ 50 }
                strokeWidth={ 16 }
            />
        </Root>
    );
}

const rotate = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

const initialFill = keyframes`
    100% {
        stroke-dashoffset: 270;
    }
`;

const varyLength = keyframes`
    0% {
        stroke-dashoffset: 270;
    }
    50% {
        stroke-dashoffset: 170;
    }
    100% {
        stroke-dashoffset: 276;
    }
`;

const Root = styled.svg`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
`;

const TrackRing = styled.circle`
    fill: none;
    stroke: ${ ({ theme }) => chroma(theme.color.rubin).alpha(0.2).css() };
`;

const LoadingRing = styled.circle`
    fill: none;
    stroke: ${ ({ theme }) => theme.color.rubin };
    stroke-dasharray: 270;
    stroke-dashoffset: 270;
    animation:
        ${ initialFill } 0.5s forwards,
        ${ rotate } 1.6s linear 0.2s infinite,
        ${ varyLength } 3s linear 0.5s infinite alternate;
    transform-origin: 50% 50%;
`;

export default memo(SpinningRing);
